export default "__VITE_ASSET__BSqtxRY5__"